import React from 'react';
import { FaBolt } from 'react-icons/fa';

/**
 * Compact trust element for the top of the property-search landing pages.
 * For a branded agent it shows the agent photo + name + agency; for the
 * generic home-price experience it falls back to a neutral accent badge.
 */
const AgentTrustChip = ({
  agentDetails, accentColor, size = 'md', badgeLabel = 'Instant property estimates',
}) => {
  const isBranded =
    agentDetails &&
    agentDetails.landing_page_slug &&
    agentDetails.landing_page_slug !== 'home-price' &&
    agentDetails.agent_name;

  const dim = size === 'sm' ? 32 : 36;

  if (isBranded) {
    return (
      <div className="psl-chip">
        {agentDetails.agent_profile_image && (
          <img
            src={agentDetails.agent_profile_image}
            alt={agentDetails.agent_name}
            style={{ width: dim, height: dim }}
          />
        )}
        <div className="psl-chip-text">
          <div className="psl-chip-name">{agentDetails.agent_name}</div>
          <div className="psl-chip-sub">{agentDetails.agency_name_short}</div>
        </div>
      </div>
    );
  }

  return (
    <div className="psl-badge" style={{ background: `${accentColor}14`, color: accentColor }}>
      <FaBolt size={12} /> {badgeLabel}
    </div>
  );
};

export default AgentTrustChip;
